import { Route, Routes } from "react-router-dom";
import { IntegrationProvider } from "../../../../contexts/IntegrationContext";
import ClioIntegrationPage from "./pages/ClioIntegrationPage";
import IntegrationsHomePage from "./IntegrationsHomePage";
import IntegrationCallbackPage from "./pages/IntegrationCallbackPage";

export default function IntegrationsPage() {
  return (
    <IntegrationProvider>
      <Routes>
        <Route path="/" element={<IntegrationsHomePage />} />
        <Route path="/clio" element={<ClioIntegrationPage />} />
        <Route
          path="/callback/:integrationId"
          element={<IntegrationCallbackPage />}
        />
      </Routes>
    </IntegrationProvider>
  );
}
